
import Form from "./Form.vue";

export default {
  name: "app-emitente",
  data() {
    return {};
  },
  components: {
    Form,
  },
  methods: {},
  mounted() {},
};
